import React from 'react';
import Config from 'config';
let config;
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { find, get, includes } from 'lodash';
import features from 'lib/common/features';
import formattedDate from 'lib/common/formattedDate';

/**
 * Use value of web content field, otherwise
 * fallback to performance description.
 */
function displayTitle(description, webContent) {
  const customTitle = features.getOption('details', 'displayTitleWebContentId');

  if (customTitle) {
    const webContentField = find(webContent, field => parseInt(field.content_type, 10) === customTitle);

    if (webContentField) {
      return webContentField.content_value;
    }
  }

  return description;
}

function getTheatreTitle(details) {
  config = new Config().getConfig();

  const facilityId = get(details, 'Performance.facility_no');

  const theatre = find(config.facilityMapping, facility => {
    return parseInt(facility.facility_no, 10) === parseInt(facilityId, 10);
  });

  if (theatre && theatre.title) {
    return theatre.title;
  }

  return get(details, 'Performance.facility_desc');
}

function findAdditionalMessagesToDisplay(webContent) {
  const webContentDescriptions = features.getOption('details', 'additionalMessageWebContentDescriptions');

  if (webContent.length > 0 && webContentDescriptions && webContentDescriptions.length > 0) {
    return webContent.filter(function(entry) {
      return includes(webContentDescriptions, entry.content_type_desc);
    });
  } else {
    return [];
  }
}

const Details = ({ performanceDetails }) => {
  const perfDate = get(performanceDetails, 'Performance.perf_dt') || get(performanceDetails, 'Performance.perf_date');
  const webContent = get(performanceDetails, 'WebContent', []);
  const description = get(performanceDetails, 'Performance.description');

  const additionalMessagesToDisplay = findAdditionalMessagesToDisplay(webContent);

  if (features.isEnabled('performanceType')) {
    const performanceTypeDescription = get(performanceDetails, 'Performance.performance_type', null);
    const performanceTypeId = get(performanceDetails, 'Performance.perf_type_id', null);

    const performanceTypeMapping = features.getOption('performanceType', 'customDescription');

    if (performanceTypeMapping && performanceTypeId in performanceTypeMapping) {
      additionalMessagesToDisplay.unshift({
        content_value: performanceTypeMapping[performanceTypeId],
      });
    } else if (performanceTypeDescription) {
      additionalMessagesToDisplay.unshift({
        content_value: performanceTypeDescription,
      });
    }
  }

  return (
    <header
      className={classnames({
        'syos-performance-details': true,
        'syos-performance-details--empty': !performanceDetails
      })}
    >
      <h2 className="syos-performance-details__title">
        {performanceDetails && displayTitle(description, webContent)}
      </h2>
      <h3 className="syos-performance-details__subtitle">
        {perfDate && (
          <span className="syos-performance-details__date">
            {formattedDate(perfDate)} at {getTheatreTitle(performanceDetails)}
          </span>
        )}
      </h3>
      {additionalMessagesToDisplay.length > 0 && (
        <div className="syos-performance-details__additional-messages">
          {additionalMessagesToDisplay.map((entry, key) => {
            return (
              <p key={key} className="syos-performance-details__additional-message">
                {entry.content_value}
              </p>
            );
          })}
        </div>
      )}
    </header>
  );
};

Details.propTypes = {
  performanceDetails: PropTypes.object
};

export default Details;



// WEBPACK FOOTER //
// ./src/javascripts/components/Details.js